import React, { FC } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import styles from "./error-container.module.css";

const { wrapper: wrapperClassName, "message-content": messageContentClassName } = styles;

type ErrorParams = { fromRoute?: boolean };

export const ErrorContainer: FC<ErrorParams> = ({ fromRoute }) => {
  const { code } = useParams();

  const showNotfound = code === "404" || fromRoute;

  const show403 = code === "403";

  if (show403) {
    return (
      <div className={wrapperClassName}>
        <div className={messageContentClassName}>
          <h1>Access Denied</h1>
          <p className={styles.footer}>You do not have permission to access this page.</p>
          <p className={styles.footer}>
            Click <Link to={"/"}>here</Link> to return to the dashboard.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <div className={messageContentClassName}>
        <h1>{showNotfound ? "Page not found" : "Something went wrong"}</h1>
        <p className={styles.footer}>
          {showNotfound
            ? "Sorry, we couldn't find the page you were looking for."
            : "The server encountered an internal error and was unable to complete your request."}
        </p>
        <p className={styles.footer}>
          Click <Link to={"/"}>here</Link> to return to the dashboard.
        </p>
      </div>
    </div>
  );
};
